"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var CurrencyUtils_1 = require("../../../../../utils/CurrencyUtils");
var CalculatorContextInterface_1 = require("../CalculatorContextInterface");
var CalculatorTotalPrice = function () {
    var _a = (0, CalculatorContextInterface_1.useCalculatorContext)(), defaultCurrency = _a.defaultCurrency, payAmount = _a.payAmount, payment = _a.payment;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_hook_form_1.useFormContext)(), register = _c.register, errors = _c.formState.errors;
    var _d = (0, react_1.useState)(0), value = _d[0], setValue = _d[1];
    (0, react_1.useEffect)(function () {
        if (payment && payAmount) {
            var _value = payAmount + (payAmount * payment.commission / 100);
            setValue(_value);
        }
        else if (payAmount) {
            setValue(payAmount);
        }
    }, [payAmount, payment]);
    return (react_1.default.createElement("div", { className: "__wrap-item" },
        react_1.default.createElement("span", { className: "__info" },
            " ",
            t("calculator.sumit.total_price")),
        react_1.default.createElement("span", { className: "__value" },
            CurrencyUtils_1.CurrencyUtils.symbol(payment ? payment.currency_code : defaultCurrency),
            " ",
            value.toFixed(2))));
};
exports.default = CalculatorTotalPrice;
